import {IProduct} from "../../../infrastructure/interfaces";
import * as React from "react";
import {Modal} from "../../Modal";
import Button from "../../Button";
import './PreviewProductModal.css';
import MarkdownRenderer from '../../Editor/components/CropPageView/common/MarkdownRenderer'
import {connect} from "react-redux";
import { changeZoom } from '../../../actions/actions';
import ProductPreview from "src/components/ProductPreview/ProductPreview";

export interface PreviewProductProps {
    show: any;
    onClose: any;
    product: IProduct;
    resetZoom?(type: string): void;
}

export interface PreviewProductState {
}

const mapDispatchToProps = (dispatch: any): any => {
    return {
      resetZoom: (type: string) => {
        dispatch(changeZoom(type));
      },
    };
  };
  

const mapStateToProps = (state: any): any => {
    return {
    };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class PreviewProductModal extends React.Component<PreviewProductProps, PreviewProductState> {
    constructor(props: PreviewProductProps) {
        super(props);
        this.resetZoom();
    }

    resetZoom() {
        if (this.props.resetZoom) {
            this.props.resetZoom('reset');   
        }
    }

    closeModal = () => this.setState({ showModal: false});

    render() {

        var wrapperContainerClass = "previewCatalogWrapperContainer";
        var subWrapperContainerClass = "previewCatalogSubWrapperContainer";

        if (this.props.product.type.toUpperCase() == "BROCHURE") {
            wrapperContainerClass = "previewBrochureWrapperContainer"
            subWrapperContainerClass = "previewBrochureSubWrapperContainer";
        } else if (this.props.product.type.toUpperCase() == "BULLETIN") {
            wrapperContainerClass = "previewBulletinWrapperContainer"
            subWrapperContainerClass = "previewBulletinSubWrapperContainer";
        }


        return (
            <Modal show={this.props.show}
                   onClose={this.props.onClose}
                   className="extra-large-modal"
            >
                <Modal.Header>
                    <MarkdownRenderer
                        markdown={this.props.product.name}
                        className={"previewProductTitle"} />
                    <Button bsClass="close" onClick={this.props.onClose}></Button>
                </Modal.Header>
                <Modal.Body>
                    <div className={wrapperContainerClass}>
                        <div className={subWrapperContainerClass}>
                            <ProductPreview
                                templateType={(this.props.product.templateType != null) ? this.props.product.templateType : "type1"}
                                productType={this.props.product.type}
                                product={this.props.product}
                                productName={this.props.product.name}
                                category={this.props.product.category}
                                category_2={this.props.product.category_2}
                                group={this.props.product.group}
                                positioningStatement={this.props.product.statement}
                                features={this.props.product.features}
                                benefits={(this.props.product.grower_benefits != null) ? this.props.product.grower_benefits : ""}
                                rates={this.props.product.rates}
                                activeIngredients={this.props.product.active_ingredients}
                                analysis={this.props.product.analysis}
                                targetChemistries={this.props.product.target_chemistries}
                                disclaimer_1={this.props.product.disclaimers[0]}
                                disclaimer_2={this.props.product.disclaimers[1]}
                                url={this.props.product.url}
                                iconPath={this.props.product.icon}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsClass="cancel" onClick={this.props.onClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Modals/PreviewProductModal/PreviewProductModal.tsx